interface props {
  color?: string;
}

export default function GamePadIcon({ color = 'white' }: props) {
  return (

    <svg width="2.4rem" height="2.4rem" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.5001 17.5C20.0001 21 23.9487 18.4151 23.0001 15C21.5754 9.87113 20.8002 7.01556 20.397 5.50793C20.1598 4.62136 19.3563 4 18.4385 4H5.56161C4.64388 4 3.84406 4.62481 3.62091 5.515C2.78156 8.86349 2.03266 11.8016 1.14421 15C0.195561 18.4151 4.14421 21 6.64421 17.5" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M16 4V6C16 7.10457 15.1046 8 14 8H10C8.89543 8 8 7.10457 8 6V4" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M8 16C9.10457 16 10 15.1046 10 14C10 12.8954 9.10457 12 8 12C6.89543 12 6 12.8954 6 14C6 15.1046 6.89543 16 8 16Z" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M16 16C17.1046 16 18 15.1046 18 14C18 12.8954 17.1046 12 16 12C14.8954 12 14 12.8954 14 14C14 15.1046 14.8954 16 16 16Z" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

  )
}